<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <slider
                :value="sliderIndex"
                :values="opacityValues"
                show-decimal
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'background-image-overlay',
    mixins: [baseOption],

    data() {
        return {
            customAttributeProp: 'background-overlay-opacity',
            displayName: 'Image Overlay Opacity',
            opacityValues: [
                '0',
                '0.1',
                '0.2',
                '0.3',
                '0.4',
                '0.5',
                '0.6',
                '0.7',
                '0.8',
                '0.9',
                '1',
            ],
            sliderIndex: 0,
        };
    },

    methods: {
        onInput(newIndex) {
            const opacity = this.opacityValues[newIndex];

            this.selectedElements[0].setElementData(this.customAttributeProp, opacity);
            this.sliderIndex = newIndex;
            this.onOptionChange(opacity);
        },

        onSelectedElement() {
            const opacity = this.selectedElements[0].getElementData(this.customAttributeProp);

            this.sliderIndex = opacity
                ? this.opacityValues.indexOf(opacity)
                : this.opacityValues.length - 1;
        },
    },
};
</script>
